import { render } from "./MakePaymentView.vue?vue&type=template&id=72395312"
import script from "./MakePaymentView.vue?vue&type=script&lang=js"
export * from "./MakePaymentView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__